"use client";

import { ChartCard } from "@/components/ui/chart-card";
import { BarChartSkeleton } from "@/components/ui/chart-skeletons";

export default function NewEntrantsSkeleton() {
  return (
    <ChartCard 
      title="New Entrants"
      subtitle="Number of new apps entering the market over different timeframes"
    >
      <div className="-mx-2">
        <BarChartSkeleton barCount={5} heights={[40, 65, 50, 75, 55]} className="h-56" />
      </div>
    </ChartCard>
  );
}
